import { FC, memo } from 'react'
import { PlaceholderCell } from 'components/extend/PlaceholderCell'
import { ModalSimple } from 'components/ModalSimple'
import { formattedSerialId } from 'modules/order/helpers'

import { OrderCancelForm } from '../OrderCancelForm/OrderCancelForm'
import { ModalCancelProps } from './types'

const ModalCancel: FC<ModalCancelProps> = (props) => {
  const { id, focusedOrder, serialId, orderId, onClose, refetch, refetchTable, cancelOrder, isSubmitting } = props

  return (
    <ModalSimple
      id={id}
      onClose={onClose}
      title={
        isSubmitting ? (
          <PlaceholderCell height={32} />
        ) : (
          <div>
            Подтвердите отмену заявки
            <br />
            {/* @ts-ignore */}
            {formattedSerialId(focusedOrder?.col1.serialId || serialId)}
          </div>
        )
      }
    >
      <OrderCancelForm
        cancelOrder={cancelOrder}
        id={focusedOrder?.id || orderId}
        isSubmitting={isSubmitting}
        onClose={onClose}
        refetch={refetch}
        refetchTable={refetchTable}
      />
    </ModalSimple>
  )
}

export default memo(ModalCancel)
